import { useEffect, useState } from 'react';
import axios from '../helpers/axios'

export const createSupplierFeedback = async (values, callback) => {
    const res = await axios.post(`/supplierfeedback/createsupfeedback`, values);
    callback(res.data.response)
}
export const updateSupplierFeedback = async (id, values, callback) => {
    const res = await axios.put(`/supplierfeedback/updatesupfeedback/${id}`, values);
    callback(res.data.response);
}

export const deleteSupplierFeedback = async (id, values, callback) => {
    const res = await axios.put(`/supplierfeedback/deletesupfeedback/${id}`, { updatedBy: values });
    callback(res.data.response);
}

export const getAllSupplierFeedback = async (rowPerPage, pageNumber, search, callback) => {
    const res = await axios.get(`/supplierfeedback/?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}&search=${search}`)
    callback(res.data.response)
}

export const getAllSupplierFeedbackById = async (id, callback) => {
    const res = await axios.get(`/supplierfeedback/getalldetailbyid/${id}`);
    callback(res.data.response)
}

export const getSupplierFeedbackById = async (id, callback) => {
    const res = await axios.get(`/supplierfeedback/${id}`);
    callback(res.data.response)
}

export const getSupplierFeedbackByParentId = async (id, callback) => {
    const res = await axios.get(`/supplierfeedback/getbyparentid/${id}`);
    callback(res.data.response)
}

export const SupplierFeedbackAPI = () => {
    const [supplierFeedbacks, setSupplierFeedbacks] = useState([]);
    const [supplierFeedbackDetail, setSupplierFeedbackDetail] = useState({});

    const [rowPerPage, setRowPerPage] = useState(10);
    const [search, setSearch] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [callback, setCallback] = useState(false);
    const [supplierFeedbackId, setSupplierFeedbackId] = useState(0);

    useEffect(() => {
        getAllSupplierFeedback(rowPerPage, pageNumber, search, res => {
            setSupplierFeedbacks(res.data);
        });

        getSupplierFeedbackById(supplierFeedbackId, res => {
            setSupplierFeedbackDetail(res.data)
        });
    }, [callback, rowPerPage, search, pageNumber, supplierFeedbackId])

    return {
        supplierFeedbacks: [supplierFeedbacks, setSupplierFeedbacks],
        supplierFeedbackDetail: [supplierFeedbackDetail, setSupplierFeedbackDetail],
        supplierFeedbackId: [supplierFeedbackId, setSupplierFeedbackId],
        rowPerPage: [rowPerPage, setRowPerPage],
        search: [setSearch],
        pageNumber: [pageNumber, setPageNumber],
        totalPages: [totalPages, setTotalPages],
        callback: [callback, setCallback]
    }
}